<ng-container *ngIf="model && model.view">
  <div
    [id]="'file-item-' + resultsIndex"
    #element
    class="file-item"
    [class.blur]="confirmOptions"
    tabindex="-1"
    [dragAndDrop]="dragData"
    data-cy="mail-item"
    [class.hasAttachments]="viewModel?.attachments?.length > 0 || viewModel?.hasAttachment"
    [class.isStarred]="viewModel.isStarred"
    [ngClass]="{ 'preview-mode': previewState === 'side' }"
  >
    <link-indicator
      class="link-indicator"
      *ngIf="model.linkIndicator"
      [name]="model.link?.name"
      [color]="model.link?.color"
      [isRestricted]="viewModel.isRestricted"
    ></link-indicator>
    <div class="content-container">
      <div class="sender-container" [ngClass]="{ hasAttachments: viewModel.attachments }">
        <div class="circle">
          <div
            *ngIf="viewModel.isUnread"
            data-cy="mail-item-unread-icon"
            class="unread"
            pTooltip="Unread"
            tooltipPosition="bottom"
            tooltipStyleClass="u-tooltip"
          ></div>
        </div>
        <result-title
          data-cy="mail-item-sender-name"
          class="sender-name"
          [model]="viewModel.sender"
          [highlights]="model.highlights"
          (invoke)="
            onInvoke({
              command: $event.command,
              context: makeContext({ appId: model.resource.appId, openWith: model.openWith }, $event.context),
              trigger: $event.trigger,
              source: $event.source,
              immediate: $event.immediate,
            })
          "
        ></result-title>
      </div>
      <div class="middle-wrapper" data-cy="mail-item-middle-wrapper">
        <div class="main" #main>
          <div class="title-container result-line" *ngIf="model.view" [class.with-subtitle]="model.view.subtitle">
            <div class="titles-container">
              <div class="main-title-container">
                <result-tag
                  data-cy="mail-item-label"
                  *ngFor="let label of viewModel.labels"
                  [model]="label"
                  [defaultBackgroundColor]="'var(--primary-400)'"
                  [dragMetadata]="dragMetadata"
                  #tags
                ></result-tag>
                <result-title
                  [model]="viewModel.title"
                  [highlights]="model.highlights"
                  [showSingleLineView]="true"
                  (contextmenu)="viewModel.title.onRightClick ? null : onRightClick($event, 'title')"
                  (auxclick)="viewModel.title.onRightClick ? null : onAuxClick($event, 'title')"
                  (invoke)="
                    onInvoke({
                      command: $event.command,
                      context: makeContext({ appId: model.resource.appId, openWith: model.openWith }, $event.context),
                      trigger: $event.trigger,
                      source: $event.source,
                      immediate: $event.immediate,
                    })
                  "
                  [selected]="selected"
                  [dragMetadata]="dragMetadata"
                  click-invoker
                  #title
                  class="mail-result-title"
                  data-cy="mail-item-title"
                >
                </result-title>
                <p *ngIf="viewModel.subtitle?.length" class="seperator">-</p>
              </div>
              <result-subtitle
                *ngIf="viewModel.subtitle"
                [model]="viewModel.subtitle"
                [highlights]="model.highlights"
                (contextmenu)="viewModel.subtitle.onRightClick ? null : onRightClick($event, 'subtitle')"
                (auxclick)="viewModel.subtitle.onRightClick ? null : onAuxClick($event, 'subtitle')"
                #subtitle
                class="mail-result-subtitle"
                data-cy="mail-item-subtitle"
              >
              </result-subtitle>
            </div>
          </div>
          <div
            class="attachments-container result-line"
            tabindex="-1"
            *ngIf="!displayOneLine && viewModel.attachments?.length > 0"
            data-cy="mail-attachments"
          >
            <result-attachment
              data-cy="mail-item-attachment"
              *ngFor="let attachment of viewModel.attachments"
              [model]="attachment"
              [dragMetadata]="dragMetadata"
              [smallWidth]="preview"
              click-invoker
              (invoke)="invoke.emit({ command: $event, trigger: 'mouse_click', invokerItem: model })"
            >
            </result-attachment>
          </div>
        </div>
        <ng-container *featureFlagEnabled="DISABLED_FAVORITES_WORKSPACE_FEATURE_FLAG">
          <div class="favorite" click-invoker *ngIf="model?.isFavorite">
            <i class="font-icon icon-star-solid"></i>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="buttons-container">
      <div class="creation-time">
        <u-icon
          data-cy="mail-item-attachment-icon"
          class="attachment-indication"
          [model]="{ type: 'font', value: 'icon-paperclip-side' }"
          [styles]="{ width: '16px', height: '16px' }"
          *ngIf="viewModel.hasAttachment && !viewModel.hasCalendarAttachment"
        ></u-icon>
        <u-icon
          data-cy="mail-item-calendar-icon"
          class="attachment-indication"
          [model]="{ type: 'font', value: 'icon-calendar-empty' }"
          [styles]="{ width: '16px', height: '16px' }"
          *ngIf="viewModel.hasCalendarAttachment"
        ></u-icon>
        <p data-cy="mail-item-time">{{ viewModel.creationTime }}</p>
        <div
          data-cy="mail-item-star-icon"
          class="isStarred"
          *ngIf="viewModel.isStarred"
          pTooltip="Starred"
          tooltipPosition="bottom"
          tooltipStyleClass="u-tooltip"
        ></div>
      </div>
      <div class="restricted">
        <restricted-message *ngIf="viewModel.isRestricted && selected"></restricted-message>
        <u-icon
          *ngIf="pageType === 'search'"
          class="indicate-preview"
          (click)="onPreviewClick()"
          [model]="INDICATE_PREVIEW_ICON"
          pTooltip="Preview"
          tooltipPosition="top"
          tooltipStyleClass="u-tooltip"
        ></u-icon>
        <square-button
          [active]="contextMenuHelper?.source === 'actions'"
          click-invoker
          (click)="$event.stopPropagation(); openContextMenu($event, 'actions')"
          (auxclick)="$event.stopPropagation(); openContextMenu($event, 'actions')"
          (contextmenu)="$event.stopPropagation(); openContextMenu($event, 'actions')"
          #actions
          >•••</square-button
        >
      </div>
    </div>

    <div class="blocker" *ngIf="model.deleted"></div>
    <div class="confirm" *ngIf="confirmOptions" (click)="onConfirm(null, $event)">
      <span class="message" *ngIf="confirmOptions.message !== null">{{ confirmOptions.message || 'Are you sure?' }}</span>
      <button class="cancel-btn" (click)="onConfirm(false, $event)">
        <i class="far fa-times-circle"></i>{{ confirmOptions.cancelText || 'No' }}
      </button>
      <button class="confirm-btn" (click)="onConfirm(true, $event)">
        <i class="far fa-check-circle"></i>{{ confirmOptions.confirmText || 'Yes' }}
      </button>
    </div>
  </div>
</ng-container>
